import React, { useState } from "react";
import { Play, Video as VideoIcon, X } from "lucide-react";
import { visions } from "../mock";

const ytId = (url) => {
  if (!url) return "";
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
  return m ? m[1] : "";
};

const VisionCard = ({ card, onOpen }) => {
  const hasVideo = card.videoUrl && card.videoUrl.trim() !== "";
  const id = ytId(card.videoUrl);
  return (
    <div className="bg-campaign-cream border-4 border-campaign-ink shadow-brutal hover-lift flex flex-col">
      <button
        onClick={() => hasVideo && onOpen(card)}
        className={`relative w-full aspect-video border-b-4 border-campaign-ink overflow-hidden ${
          hasVideo ? "cursor-pointer group" : "cursor-default"
        }`}
      >
        {hasVideo && id && (
          <img
            src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`}
            alt={card.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
        <div
          className={`absolute inset-0 flex items-center justify-center ${
            hasVideo && id ? "bg-campaign-ink/30" : "bg-campaign-blue"
          }`}
        >
          {hasVideo ? (
            <span className="w-16 h-16 rounded-full bg-campaign-coral border-4 border-campaign-cream flex items-center justify-center group-hover:scale-110 transition-transform">
              <Play size={26} className="text-campaign-cream fill-current ml-1" />
            </span>
          ) : (
            <span className="flex flex-col items-center text-campaign-yellow">
              <VideoIcon size={40} />
              <span className="mt-2 font-bold uppercase text-xs tracking-widest text-campaign-cream/80">
                Video čoskoro
              </span>
            </span>
          )}
        </div>
      </button>
      <div className="p-5 sm:p-6 flex flex-col flex-1">
        <h3 className="font-display text-xl sm:text-2xl text-campaign-ink uppercase mb-3">
          {card.title}
        </h3>
        <p className="text-campaign-ink/80 leading-relaxed">{card.text}</p>
      </div>
    </div>
  );
};

// Prevedie bežné YouTube URL na embed formu; ostatné URL vráti bez zmeny.
const toEmbed = (url) => {
  if (!url) return "";
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1`;
  return url;
};

const Visions = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="manifest" className="bg-campaign-blue py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-display text-4xl sm:text-6xl text-campaign-yellow leading-none uppercase">
            {visions.heading}
          </h2>
          <p className="mt-4 text-campaign-cream/90 max-w-2xl mx-auto text-base sm:text-lg">
            {visions.intro}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {visions.cards.map((card, i) => (
            <VisionCard key={i} card={card} onOpen={setActive} />
          ))}
        </div>
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-campaign-ink/90 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setActive(null)}
              className="absolute -top-12 right-0 text-campaign-cream flex items-center gap-1 font-bold uppercase"
            >
              <X size={22} /> Zavrieť
            </button>
            <div className="aspect-video border-4 border-campaign-yellow bg-black">
              <iframe
                className="w-full h-full"
                src={toEmbed(active.videoUrl)}
                title={active.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Visions;
